// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBVAuPT-JfzoiOxOCEpIMC4lrMvUgjH2PM",
  authDomain: "twitter-clone-9e9be.firebaseapp.com",
  databaseURL: "https://twitter-clone-9e9be.firebaseio.com",
  projectId: "twitter-clone-9e9be",
  storageBucket: "twitter-clone-9e9be.appspot.com",
  messagingSenderId: "674387293729",
  appId: "1:674387293729:web:f37c2d5850687555aa5560",
  measurementId: "G-SXFPMNEJE2",
};

//Firebase initialize constructor function. Connected ti the back end

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
